(function () {
  var HEADING = /^H[2-4]$/;

  function isHeading(el) {
    if (!el || el.nodeType !== 1) return false;
    if (HEADING.test(el.tagName)) return true;
    if (el.tagName !== 'P') return false;
    var strong = el.querySelector('strong, b');
    if (!strong || strong.parentNode !== el) return false;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var strongText = (strong.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 0 && text.length <= 80 && text === strongText;
  }

  function headingLabel(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function accordionize(root) {
    if (!root || root.getAttribute('data-accordionized') === 'true') return;
    if (root.querySelector('details')) {
      root.setAttribute('data-accordionized', 'true');
      return;
    }

    var children = Array.prototype.slice.call(root.children);
    var headingIndexes = [];
    for (var i = 0; i < children.length; i++) {
      if (isHeading(children[i])) headingIndexes.push(i);
    }

    var startHeadingPos = isHeading(children[0]) ? 1 : 0;
    if (headingIndexes.length <= startHeadingPos) {
      root.setAttribute('data-accordionized', 'true');
      return;
    }

    var fragment = document.createDocumentFragment();
    var firstAccordionChildIndex = headingIndexes[startHeadingPos];

    for (var h = startHeadingPos; h < headingIndexes.length; h++) {
      var start = headingIndexes[h];
      var end = h + 1 < headingIndexes.length ? headingIndexes[h + 1] : children.length;
      var headingEl = children[start];
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.textContent = headingLabel(headingEl);
      details.appendChild(summary);
      var body = document.createElement('div');
      for (var n = start + 1; n < end; n++) {
        body.appendChild(children[n]);
      }
      details.appendChild(body);
      fragment.appendChild(details);
      headingEl.remove();
    }

    var insertAfter = children[firstAccordionChildIndex - 1];
    if (insertAfter && insertAfter.parentNode === root) {
      insertAfter.parentNode.insertBefore(fragment, insertAfter.nextSibling);
    } else {
      root.appendChild(fragment);
    }

    root.setAttribute('data-accordionized', 'true');
  }

  function run() {
    var roots = document.querySelectorAll(
      '[data-product-description], .product-readmore.rte'
    );
    for (var i = 0; i < roots.length; i++) {
      accordionize(roots[i]);
    }
  }

  run();
  document.addEventListener('shopify:section:load', run);
})();
